
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TReturnDialogForm, TApplyRebackCoursePackage } from '@/types/views/school';
import { applyRebackCoursePackage } from '@/api/school';
@Component({})
export default class App extends Vue {
    @Prop({
        type: Function,
        default() {
            return function() {}
        }
    })
    getData!: Function

    @Prop({
        type: Object,
        default() {
            return {}
        }
    })
    info!: TReturnDialogForm
    private dialogVisible = false
    private reason = ''

    private handleClose() {
        this.dialogVisible = false
        this.reason = ''
    }
    private async handlePost() {
        let opts: TApplyRebackCoursePackage = {
          applyReason: this.reason,
          packageId: this.info.id
        }
        try {
          await applyRebackCoursePackage(opts)
          this.$message.success('返还申请提交成功.')
          this.getData()
          this.handleClose()
        } catch (e) {
          this.$message.error(e.message)
        }
      }
}
